import { Appointment, SUBJECT_KEYS } from "@elixir/types";
import { ReactComponent as LocationDotSolid } from "../../../../assets/icons/font-awesome/location-dot-regular.svg";
import { onAddAddressAction } from "../../../../utils/bridges/methods";
import { ChipWithTooltip } from "ui";
import { getAclViewClassName } from "@elixir/utils";

const AddAddress = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  return (
    <ChipWithTooltip
      onClick={() => {
        onAddAddressAction(apt);
      }}
      className={`h-32 flex-1 ${className} ${getAclViewClassName(SUBJECT_KEYS.ADD_PATIENT_ADDRESS)}`}
      icon={<LocationDotSolid className="dr-min-w-14 dr-h-14" />}
      title="Address"
      tooltipText="Add Address"
      type={type}
    />
  );
};

export default AddAddress;
